<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать партнера</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput
                            v-model="partner.title"
                            label="Название"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.legal_entity"
                            label="Юр. лицо"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.individual_taxpayer_number"
                            label="ИНН"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.contract_id"
                            label="№ договора"
                            :horizontal="true"
                        />
                        <CRow class="mb-3">
                            <CCol cols="12" md="3"> Дата договора: </CCol>
                            <CCol
                                cols="12"
                                md="9"
                                class="pl-2">
                                <DatePicker
                                    v-model="datepicker.date"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="custom-datepicker"
                                    placeholder="Выберите дату..."
                                />
                            </CCol>
                        </CRow>
                        <PartnerSignersUpdate :signers="partner.signers" @set-signers="setSigners" />
                        <CInput
                            v-model="partner.commission"
                            label="Комиссия VIP MIRCITY (%)"
                            :horizontal="true"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="$router.push('/vip-partners')"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { PAYMENT_TYPE } from '../../utils/payment';
    import { paymentTypeTitle } from '../../utils/payment-views';
    import DatePicker from 'vuejs-datepicker';
    import PartnerSignersUpdate from '@/components/partner/PartnerSignersUpdate';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';

    export default {
        name: 'PartnerCreate',

        components: {
            DatePicker,
            PartnerSignersUpdate
        },

        data() {
            return {
                partner: {
                    title: '',
                    payment: 1,
                    telegram_chat_id: '',
                    commission: 0,
                    notification_delay: null,
                    try_count: null,
                    use_product_vat: false,
                    enabled: true,
                    signers: []
                },
                signers: [],
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    date: null,
                },
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 7, label: 'НДС 7%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 105, label: 'Расчетный НДС 5/105' },
                    { value: 107, label: 'Расчетный НДС 7/107' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                    { value: 12, label: 'НДС 12% (только для онлайн-касс в Казахстане)' },
                ],
            };
        },

        computed: {
            paymentTypeOptions() {
                const options = [];
                for (const key in PAYMENT_TYPE) {
                    options.push({
                        value: PAYMENT_TYPE[key],
                        label: paymentTypeTitle(PAYMENT_TYPE[key]),
                    });
                }
                return options;
            },
        },

        mounted() {},

        methods: {
            create() {
                if (!this.partner.title) {
                    this.$root.$emit('showError', 'Укажите название партнера.');
                    return;
                }
                if (!this.partner.payment) {
                    this.$root.$emit('showError', 'Укажите тип оплаты.');
                    return;
                }
                if (this.partner.notification_delay && !this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните макс. кол-во уведомлений!');
                    return;
                }
                if (this?.partner?.notification_delay && this?.partner?.notification_delay < 20) {
                    this.$root.$emit('showError', 'Задержка повтора уведомлений не может быть меньше чем 20 сек.');
                    return;
                }
                if (!this.partner.notification_delay && this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните задержку повтора уведомлений!');
                    return;
                }
                this.partner.contract_date = moment(this.datepicker.date).format('YYYY-MM-DD');
                this.partner.commission = this.partner.commission ? +this.partner.commission : null;
                this.partner.notification_delay = this.partner.notification_delay ? +this.partner.notification_delay : null;
                this.partner.try_count = this.partner.try_count ? +this.partner.try_count : null;
                delete this.partner.signers;
                Vue.axios
                    .post('/vip-partners', this.partner)
                    .then(resp => {
                        this.signers = this.signers.map(signer => ({ ...signer, partner_id: resp.data.id }))
                        Vue.axios
                            .post(`/vip-partners/${resp.data.id}/signers`, this.signers)
                            .catch(err => {
                                this.$root.$emit('showError', 'Ошибка сохранения.');
                            });
                        this.$router.push({ path: '/vip-partners/' + resp.data.id });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setSigners(signers) {
                this.signers = signers.map(signer => ({ ...signer, partner_id: this.partner.id }));
            },

            goBack() {
                this.$router.push({ path: '/vip-partners' });
            },
        },
    };
</script>
<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
  padding: 7px;
  border-radius: 4px;
}
</style>

